import React from 'react';
import '../CSS/Pages.css'
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

const slideProperties = {
  duration: 5000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true,
  pauseOnHover: true,
};

class Pages extends React.Component {

  constructor(props) {
    super(props);
    this.firstRef = React.createRef();
    this.secondRef = React.createRef();
    this.thirdRef = React.createRef();
    this.fourthRef = React.createRef();
    this.fifthRef = React.createRef();
    this.sixthRef = React.createRef();
    this.seventhRef = React.createRef();
    this.eighthRef = React.createRef();
    this.ninthRef = React.createRef();
    this.tenthRef = React.createRef();
    this.eleventhRef = React.createRef();
    this.twelfthRef = React.createRef();
    this.thirdteenthRef = React.createRef();
    this.fourteenthRef = React.createRef();

    this.refRef = React.createRef();
    this.state = {
      isLoading: true,
    }
  }



  scroll = (ref) => {
    if (ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - 61,
        behavior: 'smooth',
      });
    }
  };

  leftmenu = () => {
    return (
      <>Not implemented</>
    )
  }
  righttext = () => {
    return (
      <>Not implemented</>
    )
  }

  reference = (refObj) => {
    return (
      <>
        <h2 ref={this.refRef}>References</h2>
        <br />
        {refObj.map((item, index) => (
          <div style={{ 'color': 'var(--ref-color)' }} key={this.constructor.name + index}>
            <p className='ref-p'>{item.ref}</p><br />
          </div>
        ))}
      </>

    )
  }

  sildeshowRender = (images) => {
    return (
      <div className="slide-container">
        <Slide {...slideProperties}>
          {images.map((slideImage, index) => (
            <div className="each-slide" key={index}>
              <div style={{
                'backgroundImage': `url(${slideImage.url})`,
                'backgroundSize': 'cover',
                'backgroundPosition': 'center',
                'backgroundRepeat': 'no-repeat',
                'height': '60vh',
                'width': 'auto',
                'textAlign': 'justify',
                'display': 'flex',
                'justifyContent': 'center',
                'flexWrap': 'wrap',
              }}>
                <span className='caption'>{slideImage.caption}</span>
              </div>
            </div>
          ))}
        </Slide>
      </div>
    )
  }


}


export default Pages;
